import { createFileRoute } from '@tanstack/react-router';

import { ProfileOnboardingPanel } from '../../features/onboarding/profile-onboarding-panel';
import { requireOnboardingStage } from '../../features/onboarding/require-onboarding-stage';

export const Route = createFileRoute('/onboarding/profile')({
  beforeLoad: ({ context, location }) =>
    requireOnboardingStage({
      queryClient: context.queryClient,
      location,
      path: '/onboarding/profile',
    }),
  component: ProfileOnboardingPanel,
});
